import { Injectable, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommandPaletteComponent } from '../components/shared/command-palette/command-palette.component';

@Injectable({
  providedIn: 'root'
})
export class CommandPaletteService {
  private dialogRef: MatDialogRef<CommandPaletteComponent> | null = null;

  constructor(private dialog: MatDialog) {
    this.setupKeyboardShortcut();
  }

  private setupKeyboardShortcut(): void {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        this.toggle();
      }
    });
  }

  open(): void {
    if (this.dialogRef) {
      return; // Already open
    }

    this.dialogRef = this.dialog.open(CommandPaletteComponent, {
      width: '600px',
      maxWidth: '90vw',
      panelClass: 'command-palette-dialog',
      hasBackdrop: true,
      backdropClass: 'command-palette-backdrop',
      disableClose: false,
      autoFocus: true
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  toggle(): void {
    if (this.dialogRef) {
      this.close();
    } else {
      this.open();
    }
  }
}

